﻿import React from 'react';
import DiscreteBarVertical from './DiscreteBarVertical';
import DiscreteBarHorizontal from './DiscreteBarHorizontal';
import { BarOrientation } from './types';
import { DiscretePalette } from '@fe/weather';

function DiscreteBar({
    data,
    orientation,
    showLabels = true
}: {
    data: DiscretePalette;
    orientation: BarOrientation;
    showLabels?: boolean;
}) {
    return orientation === BarOrientation.Horizontal ? (
        <DiscreteBarHorizontal {...data} />
    ) : (
        <DiscreteBarVertical data={data} showLabels={showLabels} />
    );
}

export default DiscreteBar;
